export default __webpack_public_path__ + "static/media/five3v3r_logo.aca85083.svg";